import React, { useCallback, useState } from 'react';

import { Button } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import { DevicesTestingFormSettings } from 'client/model/devicesTestingForm';
import * as keyset from 'i18n/DraftControlPanel';

import styles from './SmartHomeTestingDate.module.scss';
import { SmartHomeTestingDateForm } from './SmartHomeTestingDateForm';

const t = i18n(keyset);

interface Props {
    beforeButtonElement?: React.ReactNode;
    afterButtonElement?: React.ReactNode;
    formSettings: DevicesTestingFormSettings;
    afterFormSave: () => Promise<void>;
    disabled: boolean;
}

export const SmartHomeTestingDateChanger: React.FC<Props> = ({
    afterButtonElement,
    beforeButtonElement,
    formSettings,
    afterFormSave,
    disabled,
}) => {
    const [displayForm, setDisplayForm] = useState(false);

    const hideForm = useCallback(() => {
        setDisplayForm(false);
    }, []);

    const showForm = useCallback(() => {
        setDisplayForm(true);
    }, []);

    const afterSave = useCallback(async () => {
        await afterFormSave();
        hideForm();
    }, [hideForm, afterFormSave]);

    return (
        <div>
            {displayForm ? (
                <SmartHomeTestingDateForm
                    onCancel={hideForm}
                    initialSettings={formSettings}
                    afterSave={afterSave}
                    disabled={disabled}
                />
            ) : (
                <>
                    {beforeButtonElement && (
                        <div className={styles.smartHomeTestingDateChanger}>{beforeButtonElement}</div>
                    )}
                    <div className={styles.smartHomeTestingDateChanger}>
                        <Button size="s" onClick={showForm} disabled={disabled}>
                            {t('button-change-date')}
                        </Button>
                    </div>
                    {afterButtonElement && <div>{afterButtonElement}</div>}
                </>
            )}
        </div>
    );
};
